import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../app-service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router:Router,private snackBar: MatSnackBar,private authService:AuthService)
  {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.authService.getToken())
      {
        // this.snackBar.open('Authenticated..','',{
        //   duration:1000
        // });
        
        return true;
      }
      else
      {
        this.router.navigate(['/'])
        
        this.snackBar.open('Please Login to Continue..','',{
          duration:2000
        });
        return false
      }

  
  }

}
